import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isApiSuccess, setStoreActiveStatus } from "../../services/api"; // adjust path

// POST /store/toggle-status: flips a store between active and inactive
export const toggleStoreStatus = createAsyncThunk("storeStatus/toggle", async (storeId, { rejectWithValue }) => {
    try {
        const res = await setStoreActiveStatus(storeId);
        if (!isApiSuccess(res)) throw res;
        return { message: res.message, ...res.data }; // { id, is_active }
    } catch (err) {
        return rejectWithValue(err?.message || "Unable to change the store status.");
    }
});

const storeStatusSlice = createSlice({
    name: "storeStatus",
    initialState: { togglingId: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(toggleStoreStatus.pending, (state, { meta }) => { state.togglingId = meta.arg; })
            .addCase(toggleStoreStatus.fulfilled, (state) => { state.togglingId = null; })
            .addCase(toggleStoreStatus.rejected, (state) => { state.togglingId = null; });
    },
});

export default storeStatusSlice.reducer;